import type { BaseQuery, DateQuery, FilterQuery } from '@/shared/models/filter-query.model'
import { formatISO } from 'date-fns'

export const DEFAULT_BASE_QUERY: BaseQuery = {
  action: undefined,
  countryId: undefined,
  zipZoneId: undefined,
  carrierId: undefined,
  serviceGroupId: undefined,
  dimensions: {
    1: undefined,
    2: undefined,
    3: undefined,
  },
  status: [1, 2, 3, 4, 5, 6, 7],
  isUserRelated: false,
}

export const DEFAULT_DATE_QUERY: DateQuery = {
  fromViewDate: formatISO(new Date()),
  toViewDate: formatISO(new Date()),
  fromActionDate: formatISO(new Date()),
  toActionDate: formatISO(new Date()),
  isActionDate: false,
  isViewDate: true,
}

export const DEFAULT_FILTER_QUERY: FilterQuery = {
  ...DEFAULT_BASE_QUERY,
  ...DEFAULT_DATE_QUERY,
}
